import { TableCell, TableRow } from "@/components/ui/table";
import type { AdminUser } from "@/hooks/admin/users/types";

interface ProviderDetailsRowProps {
  user: AdminUser;
  getProviderStrategies: (providerId: string | undefined) => any[];
  getAssignedProvider: (providerId: string | undefined) => any | null;
}

const ProviderDetailsRow = ({ 
  user, 
  getProviderStrategies, 
  getAssignedProvider 
}: ProviderDetailsRowProps) => {
  return (
    <TableRow>
      <TableCell colSpan={6} className="bg-slate-50">
        <div className="pl-8 py-2">
          {user.provider_id ? (
            <div className="space-y-2">
              <h4 className="text-sm font-medium">Zugewiesener Strategy Provider:</h4>
              <div className="ml-4 text-sm">
                {(() => {
                  const provider = getAssignedProvider(user.provider_id);
                  return provider ? (
                    <div>
                      <p><span className="font-medium">Name:</span> {provider.name}</p>
                      {provider.url && (
                        <p>
                          <span className="font-medium">URL:</span>{' '}
                          <a href={provider.url} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                            {provider.url}
                          </a>
                        </p>
                      )}
                      <p>
                        <span className="font-medium">Status:</span>{' '}
                        <span className={provider.active ? 'text-green-600' : 'text-red-600'}>
                          {provider.active ? 'Aktiv' : 'Inaktiv'}
                        </span>
                      </p>
                    </div>
                  ) : (
                    <p className="text-gray-500 italic">Zugewiesener Provider nicht gefunden</p>
                  );
                })()}
              </div>
            </div>
          ) : (
            <p className="text-sm text-gray-500 italic">Kein Strategy Provider zugewiesen</p>
          )}

          <h4 className="text-sm font-medium mt-4 mb-2">Verwaltete Strategien:</h4>
          {getProviderStrategies(user.provider_id).length > 0 ? (
            <ul className="list-disc pl-5 text-sm space-y-1">
              {getProviderStrategies(user.provider_id).map(strategy => (
                <li key={strategy.id}>
                  {strategy.name || 'Unbenannte Strategie'} 
                  {' - '} 
                  <span className={strategy.active ? 'text-green-600' : 'text-red-600'}>
                    {strategy.active ? 'Aktiv' : 'Inaktiv'}
                  </span>
                </li>
              ))}
            </ul>
          ) : (
            <p className="text-sm text-gray-500 italic">Keine Strategien gefunden</p>
          )}
        </div>
      </TableCell>
    </TableRow>
  );
};

export default ProviderDetailsRow;
